export default __webpack_public_path__ + "static/media/resumeIcon.212f7f40.svg";